/**
 * Removes trailing slash from URL if present
 * @param {string} url - URL to process
 * @returns {string} URL without trailing slash
 */
export const stripTrailingSlash = (url) => {
  if (url?.endsWith('/')) {
    return url.slice(0, -1);
  }
  return url;
};
